import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSave, FaSpinner, FaTimes } from 'react-icons/fa';
import { CloseIcon, ColoredBellIcon } from 'ui-component/custom-icons/icons'
import toast from 'react-hot-toast';
import useIsMobile from 'utils/isMobileUtils';
import { CopyToClipboard } from 'react-copy-to-clipboard'; 

const CreateClientPortalNotificationModal = ({ openPopup, details, handleClose }) => {
    const [isFormProcessing, setIsFormProcessing] = useState(false);
    const handleProcessSubmit = () => {
        setIsFormProcessing(true);
    }

    const isMobile = useIsMobile();
    
   if (!isMobile) return (
        <Modal show={openPopup}  centered size="md">
            <Modal.Body>
                <div className="p-2">
                    <div>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <ColoredBellIcon height={'70px'} width={'70px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top form-group">
                            <div className="col-12 text-center ">
                                <div style={{ fontSize: '24px' }}>
                                    Client Portal Notification
                                </div>
                                <div className='textGray'>
                                    <div style={{ padding: '10px' }}>
                                        The credentials for the client portal have not been sent via email because the email sending feature is currently disabled.
                                    </div>
                                    <div>
                                        You can copy them and share them directly with your client.
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-top form-group">
                            <div className="col-12">
                                <div style={{ background: '#e0e0e0', borderRadius: '12px', padding: '20px' }}>
                                    <CopyToClipboard
                                        text={
                                            `Your client portal account has been created.\n` +
                                            `Click the link below to access your dashboard and set your password:\n\n` +
                                            `Your login credentials are as follows:\n` +
                                            `Link: https://mixglobal.projectmix.ai/client\n` +
                                            // `Link: ${details?.link}\n` +
                                            `Email: ${details?.email}\n` +
                                            `Password: ${details?.password}\n\n` +
                                            `Please change your password before logging in for to personalize your password.\n\n` +
                                            `Best regards,\nProjectmix Team`
                                        }
                                        onCopy={() => toast.success('Credentials copied to clipboard!')}
                                    >
                                        <div
                                            className="client-portal-notification-modal-content-copy-button"
                                            style={{ cursor: 'pointer', marginBottom: '10px' }}
                                        >
                                            Copy
                                        </div>
                                    </CopyToClipboard>
                                    <p>
                                        Your client portal account has been created.
                                    </p>
                                    <p>
                                        Click the link below to access your dashboard and set your password:
                                    </p>
                                    <p>
                                        
                                        Your login credentials are as follows:
                                    </p>

                                    <div>
                                        Link: <span className="text-primary">{details?.link ?? ''}</span>
                                    </div>
                                    <div>
                                        Email: <span className="text-primary">{details?.email ?? ''}</span>
                                    </div>
                                    <div>
                                        Password: <span className="text-primary">{details?.password ?? ''}</span>
                                    </div>
                                    <br />
                                    <div>
                                        Please change your password before logging in for to personalize your password.
                                    </div>
                                    <br />
                                    <div>
                                        Best regards, <br />
                                        Projectmix Team
                                    </div>
                                    
                                    
                                    
                                </div>
                            </div>
                        </div>
                        


                        <div className="row align-items-top mt10">
                            <div className="col-12 flex justify-content-end gap-2">
                                
                                <button onClick={handleClose} className="btn btn-main-primary btn-outlined-main" style={{ marginLeft: '4px' }}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );

    return (
            <div
                className="d-flex"
                style={{
                    width: '100vw',
                    height: '100dvh',
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    zIndex: 20,
                    background: 'rgba(0,0,0,0.07)',
                    justifyContent: 'center',
                    alignItems: 'end',
                    paddingBottom: '90px',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)'
                }}
            >
                <div
                    className="popup color-popup-mobile d-md-none"
                    style={{
                        position: 'relative',
                        transform: 'none',
                        top: 0,
                        left: 0,
                        maxWidth: '90%',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                        width: '100%',
                        padding: '24px 16px 0 16px',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <ColoredBellIcon height={'30px'} width={'30px'} />
                            <span style={{ fontWeight: 600, fontSize: 18 }}>Client Portal Notification</span>
                        </div>
                    </div>
                    <div style={{ color: '#888', fontSize: 14, marginBottom: 18 }}>
                        <div>
                            <div>
                                The credentials for the client portal have not been sent via email because the email sending feature is currently disabled.
                            </div>
                            <div>
                                You can copy them and share them directly with your client.
                            </div>
                        
                        </div>
                    </div>
                    <div className="form-group" style={{ marginBottom: 18 }}>
                        
                                    <div style={{ background: '#e0e0e0', borderRadius: '12px', padding: '20px' }}>
                                        <CopyToClipboard
                                            text={
                                                `Your client portal account has been created.\n` +
                                                `Click the link below to access your dashboard and set your password:\n\n` +
                                                `Your login credentials are as follows:\n` +
                                                `Link: https://mixglobal.projectmix.ai/client\n` +
                                                // `Link: ${details?.link}\n` +
                                                `Email: ${details?.email}\n` +
                                                `Password: ${details?.password}\n\n` +
                                                `Please change your password before logging in for to personalize your password.\n\n` +
                                                `Best regards,\nProjectmix Team`
                                            }
                                            onCopy={() => toast.success('Credentials copied to clipboard!')}
                                        >
                                            <div
                                                className="client-portal-notification-modal-content-copy-button"
                                                style={{ cursor: 'pointer', marginBottom: '10px', top: 'auto', marginTop: '-10px', marginRight: '5px' }}
                                            >
                                                Copy
                                            </div>
                                        </CopyToClipboard>
                                        <p>
                                            Your client portal account has been created.
                                        </p>
                                        <p>
                                            Click the link below to access your dashboard and set your password:
                                        </p>
                                        <p>
                                           
                                            Your login credentials are as follows:
                                        </p>

                                        <div>
                                           Link: <span className="text-primary">{details?.link ?? ''}</span>
                                        </div>
                                        <div>
                                            Email: <span className="text-primary">{details?.email ?? ''}</span>
                                        </div>
                                        <div>
                                            Password: <span className="text-primary">{details?.password ?? ''}</span>
                                        </div>
                                        <br />
                                        <div>
                                            Please change your password before logging in for to personalize your password.
                                        </div>
                                        <br />
                                        <div>
                                            Best regards, <br />
                                            Projectmix Team
                                        </div>
                                        
                                        
                                        
                                    </div>
                </div>
                
                    <div
                        className="btnarea"
                        style={{
                            position: 'sticky',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            background: '#fff',
                            padding: '16px 0 12px 0',
                            zIndex: 30,
                            display: 'flex',
                            gap: 10,
                            justifyContent: 'center',
                            marginTop: 'auto'
                        }}
                    >
                        <button
                            className="btn btn-main"
                            disabled={isFormProcessing}
                            onClick={() => {
                                if (!isFormProcessing) handleProcessSubmit();
                            }}
                        >
                            {isFormProcessing ? (
                                <>
                                    <FaSpinner className="fa-spin" /> Saving...
                                </>
                            ) : (
                                <>
                                    <FaSave /> Save
                                </>
                            )}
                        </button>
                        <button className="btn new-btn-error" onClick={handleClose}>
                            <FaTimes /> Close
                        </button>
                    </div>
                </div>
            </div>
        );
};

export default CreateClientPortalNotificationModal;
